import React from "react";

export default () => {
  return (
    <div className="loaderdiv">
      <div className="loader" aria-hidden="true"></div>
    </div>
  );
};
